export default "__VITE_ASSET__Chi_MQ9E__"